import React from 'react';
import Icon from 'atomic/icon';
import Button from 'atomic/button';
import classNames from 'classnames';

import './send-response-modal.scss';

const SendResponseModal: React.FC<{
    success: boolean;
    message: {
        title: string;
        text: string;
    }; onClose: () => void;
}> = ({
    success,
    message,
    onClose
}) => (
    <div className="send-response-modal">
        <Icon name={success ? 'check-circle' : 'alert-circle'} size={32}
            color={success ? 'fourth' : 'danger'}
        />
        <div className={classNames(
            {
                'title': true,
                'title--warning': !success,
                'title--success': success
            })}
        >
            {message.title}
        </div>
        <p>
            {message.text}
        </p>
        <Button type="button" color="primary" onClick={onClose}
            block={true} size="lg"
        >
            Zamknij
        </Button>
    </div>
);

export default SendResponseModal;
